import { AttachmentFullViewState } from 'owa-attachment-full-data';
import { AttachmentModel } from 'owa-attachment-model-store';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import createSharingDataFromReferenceAttachment from 'owa-attachment-model-store/lib/utils/createSharingDataFromReferenceAttachment';
import { SharingData } from 'owa-sharing-data';

export default function createSharingDataFromAttachments(
    viewStates: AttachmentFullViewState[]
): SharingData[] {
    return viewStates
        .filter(x => x.isCloudy)
        .map(viewState => {
            const attachment: AttachmentModel = getAttachment(viewState.attachmentId);
            return createSharingDataFromReferenceAttachment(
                attachment,
                viewState.strategy.isConvertCloudyToClassicSupported
            );
        });
}
